import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableHtmlEditorChatAssistant = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableHtmlEditorChatAssistant);
};
